import { endpoints } from '@/services/endpoints';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';
import { AppCard } from '@/components/ui/AppCard';
import { AppBarChart } from '@/components/charts/pieChart/AppBarChart';
import { useMemo } from 'react';

export default function BooksPerCategoryChart() {
  const { data: chartRaw, isLoading: chartLoading } = useQuery({
    queryKey: ['getBooksPerCategory'],
    queryFn: () => axiosGetRequest(endpoints.getBooksPerCategory),
    select: data => data.data,
  });

  // Fetch categories to get their names (the chart API only returns counts)
  const { data: categories, isLoading: catLoading } = useQuery({
    queryKey: [endpoints.getAllCategories],
    queryFn: () => axiosGetRequest(endpoints.getAllCategories),
    select: data => data.data || data.result,
  });

  // Merge category names with chart data
  const chartData = useMemo(() => {
    if (!chartRaw?.length) return [];
    return chartRaw.map((item: any, index: number) => ({
      ...item,
      category: categories?.[index]?.name_en || categories?.[index]?.name_ar || `Category ${index + 1}`,
    }));
  }, [chartRaw, categories]);

  const config = {
    count: { label: 'Count', color: '#0D9373' },
  };

  return (
    <AppCard>
      <h5 className="mb-4 text-base font-semibold text-coal-900">Books per Category</h5>
      <AppBarChart
        chartData={chartData}
        dataKey="count"
        nameKey="category"
        config={config}
        isLoading={chartLoading || catLoading}
        className="h-80"
      />
    </AppCard>
  );
}
